import React from "react";
import { AiFillGithub, AiFillLinkedin } from "react-icons/ai";
import { useLocation } from "react-router-dom";

function Footer() {
  const { pathname } = useLocation();
  if (pathname === "/" || pathname === "/index.html") return null;

  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-inner">
        <p className="footer-copy">© {year} Blu Gotlieb</p>
        <div className="footer-social">
          <a
            href="https://github.com/blu-99"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="GitHub"
            className="social-link"
          >
            <AiFillGithub />
          </a>
          <a
            href="https://www.linkedin.com/in/blu-gotlieb/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
            className="social-link"
          >
            <AiFillLinkedin />
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
